var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 14.78C18.34 15.57 17.2 16.01 16.03 16H6.36997C2.29997 15.71 2.28997 9.80004 6.36997 9.51004H6.40997C3.61997 1.75004 15.41 -1.33996 16.76 6.80004C20.53 7.28004 22.06 12.29 19.2 14.78Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.25H14.0063L13.5782 21.0788L13.3945 21.5476C13.177 22.1026 12.6273 22.5 12 22.5C11.3727 22.5 10.823 22.1026 10.6055 21.5476L10.4218 21.0788L9.99371 21.25H6C5.86614 21.25 5.75 21.1339 5.75 21C5.75 20.8661 5.86614 20.75 6 20.75H9.99371L10.4248 20.9224L10.6067 20.4495C10.7559 20.0615 11.0615 19.7559 11.4495 19.6067L11.9224 19.4248L11.75 18.9937V16.5H12.25V18.9937L12.0776 19.4248L12.5505 19.6067C12.9385 19.7559 13.2441 20.0615 13.3933 20.4495L13.5752 20.9224L14.0063 20.75H18C18.1339 20.75 18.25 20.8661 18.25 21C18.25 21.1339 18.1339 21.25 18 21.25Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudActive);
export default __webpack_public_path__ + "static/media/cloud-active.4dd166c0082e8e594a8c2d6b6de9ef31.svg";
export { ForwardRef as ReactComponent };